import React from "react"

class SidebarLeft extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            corporative_status  : "hide",
            property_status     : "hide"
          }

    }
    componentWillMount(){
    }

    handlerMenu(_section){
        let self = this;
        switch(_section) {
            case "corporative": 
                if(self.state.corporative_status=="hide"){
                    self.setState({ corporative_status : "" });
                }else{
                    self.setState({ corporative_status : "hide" });
                }

                break;
            case "property":
                if(self.state.property_status=="hide"){ self.setState({ property_status : "" });
                }else{
                    self.setState({ property_status : "hide" });
                }
                break;
            default:
                
                if(self.props.app.state.hotel_selected==_section){ 
                        this.props.setActiveHotel("");
                    }else{
                        //console.log(_section);
                        this.props.setActiveHotel(_section);
                    }
                
        } 
        
      }

    getMenu(menu){
        let self = this;
        return menu.map(function(menuItem, i) {
            if (menuItem.branch != undefined) {
                return (
                    <div key={i}>
                        <span className={menuItem.section} >{menuItem.name.en}</span>
                            <ul className="nav flex-column mb-2">
                                {menuItem.branch.map(function(subMenu, i) {
                                    if (subMenu.type == 'category') {
                                        return (<li className="nav-item" key={i}>
                                                    <span className={subMenu.section + " clickable"} onClick={self.handlerMenu.bind(self,subMenu.section)}>{subMenu.name.en} <i className={"fa " + (self.state.corporative_status=="hide"? "fa-angle-down" : "fa-angle-up" )}></i></span>
                                                    <ul className={"nav " + self.state.corporative_status} >
                                                    {subMenu.branch.map(function(subsubMenu, j) {
                                                        return (<li className="nav-subitem" key={j}>
                                                                <span className={subsubMenu.section + " clickable"} onClick={self.props.activeSection.bind(this,menuItem.section,subsubMenu.section,"","")} >{subsubMenu.name.en}</span>
                                                            </li>
                                                            );  
                                                    }
                                                    )}
                                                    </ul>  
                                                </li>
                                                );
                                    }else if(subMenu.type=='loop'){
                                        return (<li className="nav-item" key={i}>
                                                    <span className={subMenu.section + " clickable"}  onClick={self.handlerMenu.bind(self,subMenu.section)} >{subMenu.name.en} <i className={"fa " + (self.state.property_status=="hide"? "fa-angle-down" : "fa-angle-up" )}></i></span>
                                                    {self.renderHotels(subMenu.branch)}
                                                </li>
                                                );
                                    }else{
                                        return (<li className="nav-item" key={i}>
                                                    <span className={subMenu.section + " clickable"}  onClick={self.props.activeSection.bind(this,menuItem.section,subMenu.section,"","","")}  >{subMenu.name.en}</span>
                                                </li>
                                                );
                                    }
                                })}
                            </ul>
                    </div>
                )
            } else {
                return (
                    <div key={i}>
                        <span className={menuItem.section + " clickable"} onClick={self.props.activeSection.bind(this,menuItem.section,"","","")} >{menuItem.name.en}</span>
                    </div>
                )
            }
        }
        
    )};

    renderHotels(hotels_sections){
        let self = this;
        return  <ul className={"nav " + self.state.property_status} >
                    {Object.keys(self.props.hotels).map((key, index) => {
                        return (<li  className="nav-subitem" key={self.props.hotels[key]._id} >
                                    <span className={(self.props.app.state.hotel_selected==self.props.hotels[key]._id? "menu-hotel-selected" : "" ) + " clickable"}  onClick={self.handlerMenu.bind(self,self.props.hotels[key]._id)} >{self.props.hotels[key].name} <i className={"fa " + (self.props.app.state.hotel_selected==self.props.hotels[key]._id? "fa-angle-up" : "fa-angle-down" )}></i></span>
                                    {self.renderHotelsOptions(self.props.hotels[key]._id,hotels_sections)}
                                </li>);
                        })
                    }
                </ul>   
    }

    renderHotelsOptions(hotel_selected,hotels_sections){
        let self = this;
        return  <ul className={"nav " + (self.props.app.state.hotel_selected==hotel_selected? "" : "hide" )} >
                    {hotels_sections.map(function(hotelMenu, i) {
                        return (<li className="nav-subitem" key={i}>
                                <span className={hotelMenu.section + " clickable"} onClick={self.props.activeSection.bind(self,"setup",hotelMenu.section,hotel_selected,"")} >{hotelMenu.name.en}</span>
                            </li>
                            );  
                    }
                    )}
                </ul>   
    }

    getSections(submenu){
        return submenu.map((item, index) =>
            <div key={index}>
                <a className="nav-section" href="#">{ item.en }</a>
            </div>
        )
    }

    render(){
        
        

    return(
        <nav className="sidebar-setup-left">
            <div className="sidebar-sticky">
                <div className="badage start_leaper">
                    <h6 className={ "d-flex px-3 mt-4 mb-1"}>
                        START LEAPER
                        <span>START BIG TIME</span>
                    </h6>
                </div>
                {this.getMenu(this.props.menu)}

            </div>
            
        </nav>
    )}
}

export default SidebarLeft


// WEBPACK FOOTER //
// ./src/Setup/components/SidebarLeft.js